import React from "react";
import { Box } from "@mui/material";
import ProductHeroSection from "./ProductHeroSection";
import ProductOverview from "./ProductOverview";
import ProductCategories from "./ProductCategories";
import DownloadCatalogue from "./DownloadCatalogue";
import IndustriesWeServe from "./IndustriesWeServe";
import ProductComparisonTable from "./ProductComparisonTable";
import FeaturedProjects from "./FeaturedProjects";
import ProductVideoBanner from "./ProductVideoBanner";
import ProcessFlow from "./ProcessFlow";
import ProductFAQ from "./ProductFAQ";
import ProductEnquiryCTA from "./ProductEnquiryCTA";
import Seo from "./../../components/Seo";
import ProductProcessFlow from "./ProductProcessFlow";
import ProductProgressTimeline from "./ProductProgressTimeline";

export default function ProductsPage() {
  return (
    <Box>
      <Seo
        title="Our Products | Burj Al Yarmouk Industries LLC"
        description="Explore high-quality industrial products including acoustic enclosures, fuel tanks, generator accessories, steel fabrication structures, and engineered metal works manufactured in the UAE."
        url="https://burjalyarmouk.com/products"
        image="https://burjalyarmouk.com/og-banner.jpg"
        keywords="industrial products UAE, acoustic enclosures, generator canopies, steel fabrication Abu Dhabi, fuel tanks UAE, metal works UAE, Burj Al Yarmouk products"
        schema={{
          "@context": "https://schema.org",
          "@type": "ProductCatalog",
          name: "Burj Al Yarmouk Industries LLC - Product Catalog",
          url: "https://burjalyarmouk.com/products",
          description:
            "Industrial product catalog including enclosures, fuel tanks, steel fabrication, generator parts, and custom engineered metal works.",
          provider: {
            "@type": "Organization",
            name: "Burj Al Yarmouk Industries LLC",
            url: "https://burjalyarmouk.com/",
            sameAs: [
              "https://www.instagram.com/burjalyarmouk/",
              "https://www.linkedin.com/in/burj-al-yarmouk-industries-llc-417570347/",
            ],
          },
          hasProduct: [
            {
              "@type": "Product",
              name: "Acoustic & Industrial Enclosures",
              description:
                "Generator acoustic canopies, soundproof enclosures, and outdoor weatherproof enclosures.",
            },
            {
              "@type": "Product",
              name: "Fuel Tanks & Storage Solutions",
              description:
                "Above-ground tanks, skid tanks, mobile fuel tanks, and double-wall storage tanks.",
            },
            {
              "@type": "Product",
              name: "Steel Fabrication Products",
              description:
                "Platforms, ladders, walkways, structural frames, and custom steel fabrication.",
            },
            {
              "@type": "Product",
              name: "Generator Accessories & Parts",
              description:
                "Exhaust systems, silencers, ATS panels, base frames, and integrated fuel systems.",
            },
            {
              "@type": "Product",
              name: "Custom Metal Works",
              description:
                "Sheet metal fabrication, CNC cutting, machine components, and engineered metal structures.",
            },
          ],
        }}
      />

      {/* TOP SECTIONS */}
      <ProductHeroSection />
      <ProductOverview />
      <ProductCategories />
      {/* <DownloadCatalogue /> */}

      {/* MIDDLE SECTIONS */}
      <IndustriesWeServe />
      {/* <ProductComparisonTable /> */}
      {/* <FeaturedProjects /> */}
      {/* <ProductVideoBanner /> */}

      {/* PROCESS & SUPPORT */}
      <ProcessFlow />
      {/* <ProductProcessFlow />
      <ProductProgressTimeline /> */}
      <ProductFAQ />

      {/* BOTTOM CTA */}
      <ProductEnquiryCTA />
    </Box>
  );
}
